import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class OrganizerSessionService {
  getSessionOrganizerId(): string | number | null {
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return organizer?.id ?? user?.organizer?.id ?? null;
  }

  /**
   * Ensures route `?id=` matches the logged-in organizer.
   * Mismatch or missing id: syncs URL via replaceUrl and returns null on mismatch (skip API).
   */
  validateRouteOrganizerId(
    routeId: string | number | null | undefined,
    routePath: string,
    router: Router
  ): string | number | null {
    const sessionId = this.getSessionOrganizerId();
    if (sessionId == null) {
      return null;
    }

    const sessionKey = String(sessionId);

    if (routeId == null || routeId === '') {
      router.navigate([routePath], {
        queryParams: { id: sessionId },
        replaceUrl: true,
      });
      return sessionId;
    }

    if (String(routeId) !== sessionKey) {
      Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2800,
        timerProgressBar: true,
      }).fire({
        icon: 'warning',
        title: 'Invalid access. Redirecting to your profile.',
      });

      router.navigate([routePath], {
        queryParams: { id: sessionId },
        replaceUrl: true,
      });
      return null;
    }

    return sessionId;
  }
}
